import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

function UnsubscribePage() {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        // Get params from URL
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email');
        const userId = params.get('userId');

        if (!email || !userId) {
          setStatus('error');
          setMessage('Invalid unsubscribe link');
          return;
        }

        // Call unsubscribe function
        const functions = getFunctions();
        const unsubscribeFunc = httpsCallable(functions, 'apiUnsubscribeFromEmails');

        const result = await unsubscribeFunc({ email, userId });

        if (result.data.success) {
          setStatus('success');
          setMessage('You have been unsubscribed from marketing emails.');
        } else {
          setStatus('error');
          setMessage(result.data.error || 'Failed to unsubscribe');
        }

      } catch (error) {
        setStatus('error');
        setMessage('An error occurred');
      }
    };

    unsubscribe();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-turquoise-50 via-cyan-50 to-turquoise-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8">
        {status === 'loading' && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-turquoise-500 mx-auto mb-4"></div>
            <p className="text-gray-600">Processing...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Unsubscribed Successfully</h1>
            <p className="text-gray-600 mb-6">{message}</p>
            <div className="bg-blue-50 p-4 rounded-lg mb-6">
              <p className="text-sm text-blue-800">
                You will still receive important transactional emails such as receipts, security alerts, and account notifications.
              </p>
            </div>
            <button
              onClick={() => window.location.href = '/'}
              className="w-full bg-turquoise-500 hover:bg-turquoise-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
            >
              Return Home
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Error</h1>
            <p className="text-gray-600 mb-6">{message}</p>
            <button
              onClick={() => window.location.href = '/support'}
              className="w-full bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
            >
              Contact Support
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default UnsubscribePage;
